<template>
  <p class="text-neutral-text-strong text-base">
    <template v-if="matchStart !== -1"
      >{{ before }}<span class="bitts-tree-node-label__match">{{ match }}</span
      >{{ after }}</template
    >
    <template v-else>{{ label }}</template>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { label, highlightTerm = '' } = defineProps<{
  label: string;
  highlightTerm?: string;
}>();

const term = computed(() => highlightTerm.trim());
const matchStart = computed(() =>
  term.value ? label.toLowerCase().indexOf(term.value.toLowerCase()) : -1,
);
const before = computed(() => label.slice(0, matchStart.value));
const match = computed(() =>
  label.slice(matchStart.value, matchStart.value + term.value.length),
);
const after = computed(() => label.slice(matchStart.value + term.value.length));
</script>

<style scoped lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.bitts-tree-node-label__match {
  @apply font-bold bg-info-background-weak;
}
</style>
